import AnchorLink from 'react-anchor-link-smooth-scroll'
import React from 'react'
import Link from 'gatsby-link'

import AboutUsComponent from 'components/AboutUsComponent'
import ContactComponent from 'components/ContactComponent'
import CtaComponent from 'components/CtaComponent'
import LeadComponent from 'components/LeadComponent'
import LeadComponentServices from 'components/LeadComponentServices'
import SeoComponent from 'components/SeoComponent'

class ThePage extends React.Component {
  render() {
    return (
      <div>
        <SeoComponent
          title='Meteor Entwickler gesucht? Wir sind Ihr Ansprechpartner'
          description='Wir sind eine Gruppe von Meteor-Entwicklern mit Agentur-Sitz bei Köln und seit mehreren Jahren auf Meteor.js spezialisiert. Kontaktieren Sie uns doch einfach und wir besprechen Ihr Projekt persönlich.'
        />
        <LeadComponent
          leadText='Meteor Entwickler'
          subText='Wir sind eine Agentur von <b>Meteor-Entwicklern</b> mit Sitz in NRW und seit mehreren Jahren auf <b>Meteor.js</b> spezialisiert. Sehr gerne unterstützen wir Sie bei der Umsetzung Ihres Meteor-Projektes.<br/><br/>Schreiben Sie uns also gerne eine Nachricht<br/>und wir besprechen Ihr Projekt persönlich.<br/>Telefonisch oder bei einer leckeren Tasse <i class="fas fa-coffee"></i> Kaffee…'
        />
        <LeadComponentServices imageStore={this.props.imageStore}/>
        <AboutUsComponent imageStore={this.props.imageStore}/>
        <CtaComponent/>
        <ContactComponent/>
      </div>
    )
  }
}
export default ThePage



// WEBPACK FOOTER //
// ./src/pages/meteor/meteor-entwickler.js